export var SELECT_EVENT = 'SELECT_EVENT';
export var selectEvent = function selectEvent(id) {
  return {
    type: SELECT_EVENT,
    id: id
  };
};